import wx from 'weixin-js-sdk'
import $ from 'jquery'

function getWxSdk(shareContent) {
	$.ajax({
		url: "https://napi.xdf.cn/wx/jssdk/config?appId=wx065bbd0232df78cb&url=" + encodeURIComponent(window.location.href),
		type: "GET",
		dataType: "json",
	}).then(data => {
		if (data.code != 200) {
			console.log('wx分享接口请求失败', data)
			return;
		}
		const res = data.data
		wx.config({
			debug: false,
			appId: res.appId,
			timestamp: res.timestamp,
			nonceStr: res.nonceStr,
			signature: res.signature,
			jsApiList: [
				'checkJsApi',
				'onMenuShareAppMessage',
				'onMenuShareTimeline',
				'updateAppMessageShareData',
				'updateTimelineShareData'
			]
		})

		let defaultImg = 'https://file.xdf.cn/xdf-app/images/logo.png'
		let decText = '和我一起加入新东方学习吧！'
		wx.ready(function () {
			//微信6.7.2客户端以下接口
			// 分享给朋友
			wx.onMenuShareAppMessage({
				title: shareContent.title, // 分享标题
				desc: shareContent.desc || decText, // 分享描述
				link: shareContent.link,
				imgUrl: shareContent.urlLogo || defaultImg, // 分享图标
			}, function () {
				//这里是回调函数
			});
			// 分享到朋友圈
			wx.onMenuShareTimeline({
				title: shareContent.title, // 分享标题
				link: shareContent.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: shareContent.urlLogo || defaultImg, // 分享图标
			}, function () {
				//这里是回调函数
			});

			//微信6.7.2客户端以上接口
			// 分享给朋友
			wx.updateAppMessageShareData({
				title: shareContent.title, // 分享标题
				desc: shareContent.desc || decText, // 分享描述
				link: shareContent.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: shareContent.urlLogo || defaultImg, // 分享图标
			}, function () {
				//这里是回调函数
			});
			// 分享到朋友圈
			wx.updateTimelineShareData({
				title: shareContent.title, // 分享标题
				link: shareContent.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: shareContent.urlLogo || defaultImg, // 分享图标
			}, function () {
				//这里是回调函数
			})
		})
	})
}

export default {
	getWxSdk: getWxSdk
}


